module.exports = __webpack_public_path__ + "static/media/panosta-svg-100x100.ad19014d.svg";